<form class="form-container" [formGroup]="form">
    @if (f['complaintCategoryId'].value != null) {
        <h2 mat-dialog-title>{{'UPDATE_COMPLAINT_TYPE' | translate}}</h2>
    } @else {
        <h2 mat-dialog-title>{{'ADD_COMPLAINT_TYPE' | translate}}</h2>
    }
    <mat-dialog-content class="mat-typography">
        <mat-form-field appearance="outline">
            <mat-label>{{'COMPLAINT_TYPE' | translate}} </mat-label>
            <input matInput formControlName="name">
            @if (f['name'].errors) {
            <mat-error>
                @if (f['name'].errors['required']) { <span>{{'DOCUMENT_NAME_REQUIRED' | translate}}</span>}
                @if (f['name'].errors['maxlength']) { <span>{{'MAX_LENGTH_60' | translate}}</span>}
            </mat-error>
            }
        </mat-form-field>
        <mat-form-field appearance="outline">
            <mat-label>{{'DESCRIPTION' | translate}} </mat-label>
            <input matInput formControlName="description">
            @if (f['description'].errors) {
            <mat-error>
                @if (f['description'].errors['required']) { <span>{{'DESCRIPTION_REQUIRED' | translate}}</span>}
                @if (f['description'].errors['maxlength']) { <span>{{'MAX_LENGTH_300' | translate}}</span>}
            </mat-error>
            }
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>WhatsApp Name (English)</mat-label>
            <input matInput formControlName="whatsappNameEnglish" maxlength="24">
            <mat-hint align="end">{{f['whatsappNameEnglish'].value?.length || 0}}/24</mat-hint>
            @if (f['whatsappNameEnglish'].errors) {
            <mat-error>
                @if (f['whatsappNameEnglish'].errors['required']) { <span>Required</span> }
                @if (f['whatsappNameEnglish'].errors['minlength']) { <span>Min 5 characters</span> }
                @if (f['whatsappNameEnglish'].errors['maxlength']) { <span>Max 24 characters</span> }
            </mat-error>
            }
        </mat-form-field>
        <mat-form-field appearance="outline">
            <mat-label>WhatsApp Name (Urdu)</mat-label>
            <input matInput formControlName="whatsappNameUrdu" maxlength="24">
            <mat-hint align="end">{{f['whatsappNameUrdu'].value?.length || 0}}/24</mat-hint>
            @if (f['whatsappNameUrdu'].errors) {
            <mat-error>
                @if (f['whatsappNameUrdu'].errors['required']) { <span>Required</span> }
                @if (f['whatsappNameUrdu'].errors['minlength']) { <span>Min 5 characters</span> }
                @if (f['whatsappNameUrdu'].errors['maxlength']) { <span>Max 24 characters</span> }
            </mat-error>
            }
        </mat-form-field>

        <div class="col-12">
            <mat-checkbox formControlName="isPublic">{{'PUBLIC_COMPLAINT' | translate}}</mat-checkbox>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        @if (f['complaintCategoryId'].value != null) {
        <button mat-raised-button [disabled]="form.invalid" (click)="edit()" color="primary" cdkFocusInitial>{{'Save' |
            translate}} </button>
        } @else {
        <button mat-raised-button [disabled]="form.invalid" (click)="add()" color="primary" cdkFocusInitial>{{'Add_BUTTON'
            | translate}} </button>
        }
        <button mat-raised-button mat-dialog-close>{{'Cancel' | translate}}</button>
    </mat-dialog-actions>
</form>